var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoWrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#FF933C",
    stroke: "#FF933C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7417 8.41659L12 14.1583L7.34167 9.49992H10.3333C10.7917 9.49992 11.1667 9.12492 11.1667 8.66659C11.1667 8.20825 10.7917 7.83325 10.3333 7.83325H5.33333C4.875 7.83325 4.5 8.20825 4.5 8.66659V13.6666C4.5 14.1249 4.875 14.4999 5.33333 14.4999C5.79167 14.4999 6.16667 14.1249 6.16667 13.6666V10.6749L11.4083 15.9166C11.7333 16.2416 12.2583 16.2416 12.5833 15.9166L18.9083 9.59158C19.2333 9.26658 19.2333 8.74159 18.9083 8.41659C18.5917 8.09992 18.0583 8.09992 17.7417 8.41659Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoWrong);
export default __webpack_public_path__ + "static/media/autoWrong.6b7ed08b3aeb8b904ccdff4dde50f8e4.svg";
export { ForwardRef as ReactComponent };